import React, { useCallback } from 'react';
import AppearSensor from '../../baseComponents/helpers/appearSensor/AppearSensor';
import PrizesItem from './PrizesItem';
import classNames from 'classnames';
import { Scrollbar } from 'react-scrollbars-custom';
import { safeHTML } from '../../../utils/safeHTML';
import { prizeModalScrollSettings, prizes } from '../../../constants/copyright';
import Back from '../../features/back/Back';
import { useModal } from '../../../hooks/useModal';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import Navigation from '../../features/navigation/Navigation';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { useRequests } from '../../../redux/reducer/requests';
import { useTranslation } from '../../../translations';

const { title } = prizes;

const PrizesBody = React.forwardRef(function PrizesBody(
  { isGamesRatingPrizes, currentPrizes, showPrizeInfo, showAboutModal, mod },
  ref,
) {
  const {
    authData: { isWeb },
  } = useRequests();
  const { closeModal, id } = useModal();
  const { t } = useTranslation();

  const prizeClick = useCallback(
    (item) => {
      if (!showPrizeInfo) return;
      showPrizeInfo(item);
    },
    [showPrizeInfo],
  );

  return (
    <CustomModal isFullPage={true} className={'custom-modal_prizes'}>
      <div
        className={classNames(`prizes`, {
          ['prizes_' + mod]: mod,
        })}
        ref={ref}
      >
        <div className='prizes__content'>
          <Scrollbar {...prizeModalScrollSettings}>
            <div className={`prizes__data ${isWeb ? '' : 'app_margin'}`}>
              <h2 className='prizes__title'>{safeHTML(t(title))}</h2>
              <div className='prizes__list'>
                {currentPrizes?.map((item, index) => (
                  <AppearSensor key={`item-${index}`} partialVisibility={true}>
                    {({ hasBeenVisible }) => (
                      <PrizesItem
                        className={classNames('', {
                          prizes__item_show: hasBeenVisible,
                          prizes__item_big: !index,
                        })}
                        image={item.image}
                        title={
                          item.title === 'boxesTextFt.boxPrizesTitle'
                            ? t(item.title, {
                                count: item.value ?? 0,
                                boxWord: t('boxesTextFt.boxWord', { count: item.value ?? 0 }),
                              })
                            : t(item.title, { count: item.value ?? 0 })
                        }
                        description={isGamesRatingPrizes && t(item?.description)}
                        value={item?.value}
                        onClick={() => prizeClick(item)}
                      >
                        {!isGamesRatingPrizes && (
                          <CustomButton tag={'span'} className={'prizes__button'} text={t('other.more')} />
                        )}
                      </PrizesItem>
                    )}
                  </AppearSensor>
                ))}
              </div>
            </div>
          </Scrollbar>
          <div className={'prizes__footer'}>
            <Navigation />
          </div>
        </div>
        <Back
          className={`prizes__back ${isWeb ? '' : 'app_margin'}`}
          icon={'back'}
          onClick={() => closeModal({ id })}
          extraComponent={
            isGamesRatingPrizes ? null : (
              <CustomButton
                icon={'buttons/info'}
                className={'custom-button_icon custom-button_transparent prizes__info'}
                onClick={() => showAboutModal()}
              />
            )
          }
        />
      </div>
    </CustomModal>
  );
});
export default PrizesBody;
PrizesBody.propTypes = {};
